import React, { useState } from "react";
import Logo from "../assets/Logo color.png";
import { Link, useNavigate, } from "react-router-dom";
import { List } from "@phosphor-icons/react";

export default function NavBar() {
  let [optionDisplay, setOptionDisplay] = useState(false);
  let navigate = useNavigate();
  
  let toLogin = () => {
    navigate('/auth/login')
  };
  
  let toRegister = () => {
    navigate('/auth/signup')
  };
  
  return (
    <div className="flex  text-white p-10 w-[90%] flex-col m-auto ">
      <div className="flex w-full justify-between lg:w-[90%] items-center">
        <img src={Logo} alt="" className="w-24" />
        <span className=" justify-between w-[50%] lg:flex hidden">
          <Link  className="capitalize">
            About
          </Link>
          <Link  className="capitalize">
            How it works
          </Link>
          <Link href="#pricing" className="capitalize">
            price
          </Link>
          <Link  className="capitalize">
            solution
          </Link>
          <Link  className="capitalize">
            features
          </Link>
        </span>

        <div className="w-[5%] lg:flex gap-10 justify-evenly hidden">
          <button className="text-white" onClick={toLogin}>Login</button>
          <button className="bg-transparentBg text-black  w-fit p-2 rounded-full px-8 " disabled onClick={toRegister}>
            Register
          </button>
        </div>
        <List size={25} className="lg:hidden xl:hidden" onClick={()=>setOptionDisplay((current)=>!current)} />
      </div>
      <div
        className={
          optionDisplay
            ? "lg:hidden flex flex-col mt-10 justify-center items-center w-full"
            : "hidden"
        }
      >
        <span className=" justify-center items-center w-[50%] flex flex-col gap-10">
          <Link  className="capitalize text-center">
            About
          </Link>
          <Link  className="capitalize text-center">
            How it works
          </Link>
          <Link  className="capitalize text-center">
            price
          </Link>
          <Link  className="capitalize text-center">
            solution
          </Link>
          <Link  className="capitalize text-center">
            features
          </Link>
          <Link className="capitalize text-center" to={'/auth/login'}>Login</Link>
          <button className="bg-transparentBg text-black  w-fit p-2 rounded-full px-8 " disabled onClick={toRegister}>
            Register
          </button>
        </span>
      </div>
    </div>
  );
}
